<script>

import Logo from "@/components/Logo.vue";

export default {
    components: {Logo}
}

</script>
<template>
    <section class="hero is-fullheight">
        <div class="hero-body">
            <div class="container">
                <a href="/"><Logo/></a>
                <div class="columns is-centered">
                    <div class="column is-6-tablet is-4-desktop is-4-widescreen">
                        <section class="buttons inline-flex is-centered">
                            <RouterLink to="/rejestracja">
                                <b-button type="is-primary">{{ $t('auth.labels.sign_up') }}</b-button>
                            </RouterLink>
                            <RouterLink to="/logowanie">
                                <b-button type="is-link">{{ $t('auth.labels.sign_in') }}</b-button>
                            </RouterLink>
                        </section>
                        <section class="buttons is-centered">
                            <RouterLink to="/rejestracja-firmy">
                                <b-button type="is-primary" class="is-fullwidth">{{ $t('auth.labels.company_sign_up') }}</b-button>
                            </RouterLink>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
